module.exports = __webpack_public_path__ + "images/category_lp/pc/lppc-Hikaku_KaitoriCase3_0303a72a64160da7fdce1951bb07dd20.png";